// import { Link } from "react-router-dom";
// import VideoCard from "./VideoCard.js";
// import { useSelector } from "react-redux";

// const VideoSection = ({ videos }) => {
//   return (
//     <div className="callouts-wrapper">
//       <div className="container">
//         <h2>Videos</h2>

//         <div className="video-section">
//           {videos.slice(0.4).map((videos) => (
//             <VideoCard
//               videoUrl={`${videos.video_link}`}
//               customThumbnail={videos.thumbnail_link}
//             />
//           ))}
//           <VideoCard
//             videoUrl={videos[0].video_link}
//             customThumbnail={
//               "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQykzoZeCE0p7LeuyHnLYCdPP2jju9d5PaMeA&s"
//             }
//           />{" "}
//           <VideoCard videoUrl="https://www.youtube.com/embed/hc8pWLBgt5Y?si=yZSaG_-ZwES8QUjr" />
//           <VideoCard
//             videoUrl="https://www.youtube.com/embed/hc8pWLBgt5Y?si=yZSaG_-ZwES8QUjr"
//             customThumbnail="https://letsenhance.io/static/73136da51c245e80edc6ccfe44888a99/396e9/MainBefore.jpg"
//           />
//           <VideoCard
//             videoUrl="https://www.youtube.com/embed/hc8pWLBgt5Y?si=yZSaG_-ZwES8QUjr"
//             customThumbnail={
//               "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQykzoZeCE0p7LeuyHnLYCdPP2jju9d5PaMeA&s"
//             }
//           />{" "}
//           <div className="video-view-all">
//             <h1>
//               <Link to={"/gallery/video"}> View all</Link>
//             </h1>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default VideoSection;












import { Link } from "react-router-dom";
import VideoCard from "./VideoCard.js";
import { useSelector } from "react-redux";

const VideoSection = ({ videos }) => {
  return (
    <div className="callouts-wrapper" style={{paddingBottom:"50px"}}>
      <div className="container">
        <h2>Videos</h2>

        <div className="video-section">
          {videos.slice(0,2).map((videos) => (
            <VideoCard
              videoUrl={videos.video_link}
              customThumbnail={`${
                videos.thumbnail_link === "#"
                  ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQykzoZeCE0p7LeuyHnLYCdPP2jju9d5PaMeA&s"
                  : videos.thumbnail_link
              }`}
            />
          ))}
          

          
          {
            videos.length > 0 && (
                <div
            style={{
              backgroundImage: `url(${
                videos[videos.length - 1]?.thumbnail_link === "#"
                  ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQykzoZeCE0p7LeuyHnLYCdPP2jju9d5PaMeA&s"
                  : videos[videos.length - 1]?.thumbnail_link
              })`,
              backgroundRepeat:"no-repeat",
              backgroundSize:"cover"
            }}
            className="video-view-all"
          >
            <h1 >
              <Link to={"/videos"}> View all</Link>
            </h1>
          </div>
            )
          }

        
        </div>
      </div>
    </div>
  );
};

export default VideoSection;
